import React, { useEffect, useState } from "react";
import Inputbox from "../../../Components/Inputbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import {
  ClientagencysideAddressremove,
  ClientagencysideAddressUpdate,
  Patientrequestupdates,
} from "../../../../api/helper";
import { ShowToast } from "../../../../helpers/ToastService";
import DeleteModal from "../../Components/DeleteModal";

const validationSchema = Yup.object().shape({
  address: Yup.object().shape({
    // street: Yup.string().required('Street is required'),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    zipCode: Yup.string().required("Zip code is required"),
  }),
});
const Addresses = ({ info, getDteails }) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);

  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    reset();
    setShowModal(false);
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAoF8F2jhZ_6-77oYJi0hgGTbcVh-CCIEE",
    libraries: ["places"],
  });
  const handlePlaceSelect = async () => {
    const place = autocomplete.getPlace();
    const addressComponents = place.address_components;

    const getAddressComponent = (type) => {
      const component = addressComponents.find((c) => c.types.includes(type));
      return component ? component.long_name : "";
    };

    // Set country, state, and city
    setValue("address.country", getAddressComponent("country"));
    setValue(
      "address.state",
      getAddressComponent("administrative_area_level_1")
    );
    setValue("address.city", getAddressComponent("locality"));

    const streetNumber = getAddressComponent("street_number");
    const route = getAddressComponent("route");
    const sublocality = getAddressComponent("sublocality");
    const neighborhood = getAddressComponent("neighborhood");
    const premise = getAddressComponent("premise");
    const establishment = getAddressComponent("establishment");

    let fullStreet = "";

    if (establishment) {
      fullStreet = establishment;
    } else if (premise) {
      fullStreet = `${premise}, ${route || sublocality || neighborhood}`;
    } else if (streetNumber && route) {
      fullStreet = `${streetNumber} ${route}`;
    } else if (sublocality) {
      fullStreet = sublocality;
    } else if (neighborhood) {
      fullStreet = neighborhood;
    }

    if (!fullStreet) {
      fullStreet = `${getAddressComponent("locality")}, ${getAddressComponent(
        "administrative_area_level_1"
      )}, ${getAddressComponent("country")}`;
    }

    // Set the full street address in the form
    setValue("address.street", fullStreet);

    // Set the zip code
    setValue("address.zipCode", getAddressComponent("postal_code"));
  };
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    data.id = info?._id;
    const formattedData = {
      patientAddress: {
        street: data.address.street,
        city: data.address.city,
        state: data.address.state,
        country: data.address.country,
        zipCode: data.address.zipCode,
      },
      id: data.id,
    };
    // console.log(formattedData, "vformattedData====");
    // return
    try {
      const response = await ClientagencysideAddressUpdate(formattedData);
      ShowToast(response?.data?.message);
      // console.log(response?.data?.data, "response---helloo-=====");
      getDteails();
      reset();
      closeModal();
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveAddress = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
    const requestData = {
      patientRequestId: info?._id,
      addressId: deleteId,
    };
    try {
      const response = await ClientagencysideAddressremove(requestData);
      ShowToast(response?.data?.message);
      getDteails();
    } catch (error) {
      console.log(error, "error====");
    }
  };
  if (!isLoaded) return <div>Loading...</div>;
  const handleEditClick = () => {};
  return (
    <div className="container_NotesTabScreen">
      <h1>Addresses</h1>

      <table className="address-table">
        <thead>
          <tr>
            <th>Street</th>
            <th>City</th>
            <th>State</th>
            <th>Country</th>
            <th>ZipCode</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {info?.patientAddresses?.length > 0 ? (
            info?.patientAddresses.map((item, index) => (
              <tr key={item._id || index}>
                <td data-label="Street">{item.street}</td>
                <td data-label="City">{item.city}</td>
                <td data-label="State">{item.state}</td>
                <td data-label="Country">{item.country}</td>
                <td data-label="ZipCode">{item.zipCode}</td>
                <td className="custom-action-td" data-label="Action">
                  <div className="custom-dropdown">
                    <button className="custom-action-button">⋮ Actions</button>
                    <div className="custom-dropdown-menu">
                      <ul>
                        <li>
                          <button
                            className="custom-dropdown-item"
                            onClick={() => handleEditClick(item)}
                          >
                            Edit
                          </button>
                        </li>
                        <li>
                          <button
                            className="custom-dropdown-item"
                            onClick={() => handleRemoveAddress(item._id)}
                          >
                            Delete
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No address found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <button
        className="client-history__button client-history__button--save"
        style={{ alignSelf: "flex-start", display: "flex", marginTop: 5 }}
        onClick={openModal}
      >
        +Add More Addresses
      </button>
      {showModal && (
        <>
          <form
            onSubmit={handleSubmit(onSubmit)}
            style={modalStyle}
            className="form-container_twoo"
          >
            <h1 className="form-container_twoo_h1">Add Address</h1>
            <div>
              <div style={{ width: "100%" }}>
                <Autocomplete
                  onLoad={(autocompleteInstance) =>
                    setAutocomplete(autocompleteInstance)
                  }
                  onPlaceChanged={handlePlaceSelect}
                >
                  <Inputbox
                    label="Street"
                    type="text"
                    placeholder="Enter Street"
                    name="address.street"
                    register={register}
                  />
                </Autocomplete>
              </div>
              <div style={{ width: "40px" }} />
              <div style={{ width: "100%" }}>
                <Inputbox
                  label="City"
                  type="text"
                  placeholder="Enter City"
                  name="address.city"
                  register={register}
                />
                {errors.address?.city && (
                  <div className="errorMessage">
                    {errors.address.city.message}
                  </div>
                )}
              </div>
              <div style={{ width: "40px" }} />
              <div style={{ width: "100%" }}>
                <Inputbox
                  label="State"
                  type="text"
                  placeholder="Enter State"
                  name="address.state"
                  register={register}
                />
                {errors.address?.state && (
                  <div className="errorMessage">
                    {errors.address.state.message}
                  </div>
                )}
              </div>
              <div style={{ width: "40px" }} />
              <div style={{ width: "100%" }}>
                <Inputbox
                  label="ZIP Code"
                  type="text"
                  placeholder="Enter ZIP Code"
                  name="address.zipCode"
                  register={register}
                />
                {errors.address?.zipCode && (
                  <div className="errorMessage">
                    {errors.address.zipCode.message}
                  </div>
                )}
              </div>

              <div className="button-group" style={{ marginTop: 20 }}>
                <button
                  type="button"
                  className="btn cancel"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="submit" className="btn save">
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </>
      )}
      {confirmdeletemodal && (
        <DeleteModal
          name="Address"
          onClose={() => setconfirmdeletemodal(false)}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
};

export default Addresses;
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  boxShadow: 24,
  p: 4,
  borderRadius: 10,
  outline: "none",
  overflowY: "auto",
  backgroundColor: "white",
  border: "1px solid grey",
};
